// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_5f0d0fd8","logo":"rdg_092d8214","tagLine":"rdg_68feb25e"};